import React from "react";
import { withStyles } from "@material-ui/core";
import red from "@material-ui/core/colors/red.js";
import Button from "@material-ui/core/Button";

export default withStyles({
  root: {
    backgroundColor: red[600],
    textTransform: "none",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: red[800],
    },
    "&:disabled": {
      backgroundColor: red[800],
      opacity: "0.6",
    },
  },
})((props) => <Button {...props} variant="contained" />);
